// extracted by mini-css-extract-plugin
export var fadeInAnimation = "FullscreenButton-module--fadeInAnimation--39643";
export var icon = "FullscreenButton-module--icon--ac707";
export var wrapper = "FullscreenButton-module--wrapper--2312a";